import { useEffect, useState } from 'react'
import pageService from 'services/pageService'
import { CorporatePageProps } from 'types/corporatePage'

export default function useCorporatePage() {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState<CorporatePageProps | undefined>(undefined)

  const fetchData = async () => {
    const items = await pageService.getCorporatePage()

    setData(items)
    setLoading(false)
  }

  useEffect(() => {
    fetchData()
  }, [])

  return { data, loading }
}
